<script>
export default {
  metaInfo: {
    title: '404',
  },
};
</script>

<template>
  <div class="container">
    <teleport to="title">
      404 Page
    </teleport>
    <p class="fsize-10 text-center">
      This page does not exist
      <br>
      <router-link class="fsize-5 color-main" to="/">Back to home page</router-link>
    </p>
  </div>
</template>
